import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';
import { GradientZod } from '@/types/GradientType';
import { TagZod } from '@/types/TagType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

export const ClientZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  title: TitleZod,
  paragraph: ParagraphZod,
  shape: z.enum(['convex', 'concave', 'wavy']),
  gradient: GradientZod,
  tags: z.array(TagZod),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
  client: z.object({
    prev: z
      .object({
        name: z.string(),
        slug: z.string(),
      })
      .partial(),
    next: z
      .object({
        name: z.string(),
        slug: z.string(),
      })
      .partial(),
  }),
});

export type ClientType = z.infer<typeof ClientZod>;

export const ClientSlugZod = ClientZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type ClientSlugType = z.infer<typeof ClientSlugZod>;
